/// <reference path="../../../../tools/typings/angularjs/angular.d.ts"/>
/// <reference path="../../components.ts"/>


module DealerwareWebComponents {

    "use strict";

    export class SettingsLoanerAgreementUploadDirectiveController {

        public static $inject : string[ ] = [
            'SettingsLoanerAgreementService'
        ];

        // TODO: error cases are not implemented for uploading.  Whoops.
        //
        private static get UPLOAD_STATUSES () : any {
            return {
                NONE:           'None',
                CHECKING:       'Checking...',
                ERROR_UPLOAD:   'Driver Agreement Upload Error',
                ERROR_STATUS:   'Unknown'
            }
        }

        private uploadStatus    : string = 'NONE';

        public onSuccess        : any;
        public parentController        : any;

        constructor(
            private SettingsLoanerAgreementService  : any
        ) {

            this.parentController.service.setStepData('upload');
        }

        private get uploadStatuses () : any {
            return SettingsLoanerAgreementUploadDirectiveController.UPLOAD_STATUSES;
        }
    }

    getDealerwareWebComponentsModule().controller(
        'SettingsLoanerAgreementUploadDirectiveController',
        SettingsLoanerAgreementUploadDirectiveController
    );


    export class SettingsLoanerAgreementUploadDirective implements ng.IDirective {
        public restrict         : string    =   'E';
        public controller       : any       =   'SettingsLoanerAgreementUploadDirectiveController';
        public controllerAs     : string    =   'LAU';
        public bindToController : boolean   =   true;
        public templateUrl      : string    =   '/components/settings/loaner-agreement/upload-directive.html';
        public scope            : Object    =   { onSuccess: '&?', parentController: '=controller' };
    }

    getDealerwareWebComponentsModule().directive(
        'dealerwareSettingsLoanerAgreementUpload',
        ( ) => new SettingsLoanerAgreementUploadDirective()
    );


    export class SettingsLoanerAgreementUploadService {

        private utils: any;

        constructor(
            public DataUtils                        : any,
            public $q                               : any,
            public DealerwareLoanerAgreementModel   : any,
            public Upload                           : any
        ) {

            this.utils = this.DataUtils.getInstance();
        }

        public uploadFile ( chosenFile: any, locationId: number ) : ng.IPromise<{}> {

            return chosenFile.upload({
                url : this.utils.bindEndpoint (
                    this.DealerwareLoanerAgreementModel.uploadAgreement.endpoint.replace(
                        /:location_id/, locationId
                    )
                ),
                data : { file: chosenFile }
            });
        }

        public getAgreementByContractId (locationId: number, contractId : string) : ng.IPromise<{}> {

            var defer = this.$q.defer();

            this.DealerwareLoanerAgreementModel.getAgreementByContractId ({
                params: {
                    location_id: locationId,
                    reservation_id: contractId
                },
                promise: true
            })
                .then( ( response : any ) => {
                    defer.resolve (response.data);
                })
                .catch( ( response : any ) => {
                    defer.reject (response);
                });

            return defer.promise;
        }
    }

    getDealerwareWebComponentsModule().factory('SettingsLoanerAgreementUploadService', (
        DataUtils                       : any,
        $q                              : any,
        DealerwareLoanerAgreementModel  : any,
        Upload                          : any
    ) => new SettingsLoanerAgreementUploadService (DataUtils, $q, DealerwareLoanerAgreementModel, Upload));

}

